import {
  observatoryFlags,
  type ObservatoryFlagKey,
} from "@softmax/web-features/flags";

export const playSignedInRoutes = new Set([
  "game.play",
  "game.playEpisodes",
  "game.playRequests",
  "game.playActivity",
  "game.submit",
]);

export const signedInRoutes = new Set([
  "coworlds",
  "coworldManage",
  "coworldNewRun",
  "coworldRun",
  ...playSignedInRoutes,
  "search",
  "game.search",
  "account",
  "accountAdvanced",
  "accountCredentials",
  "play",
  "lobby",
]);

export const routeFlags = new Map<string, ObservatoryFlagKey>([
  ...[...playSignedInRoutes].map(
    (name) => [name, observatoryFlags.websitePlay] as const,
  ),
  ["search", observatoryFlags.websiteTopnav],
  ["game.search", observatoryFlags.websiteTopnav],
  ["accountAdvanced", observatoryFlags.websiteAccount],
  ["game.previewEdit", observatoryFlags.storePageEditor],
  ["game.start", observatoryFlags.previewStartTeam],
  ["game.startProgress", observatoryFlags.previewStartTeam],
]);
